import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';
import {ClassroomVideoStore} from './ClassroomVideoStore';

@observer
export class LocalVideo extends React.Component<{ store: ClassroomVideoStore }> {
  render() {
    const store = this.props.store;
    const userMedia = store.localMedia.userMedia;

    const className = classNames('local-video', {
      invalid: userMedia === null,
      pending: userMedia?.isPending === true,
      failed: userMedia?.isRejected === true,
      allowed: userMedia?.isResolved === true
    });

    return (
      <div className={className} key="local-video">
        <video className="local-video"
               autoPlay
               playsInline
               ref={store.localVideoRef}/>
      </div>);
  }
}
